import React, { useState , useEffect} from "react";
import { Layout, Typography, Button, Row, Col, Space } from 'antd';
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "./FreeTrialPageStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { getScriptStatus } from "../../api/password";  
import { isNull } from "lodash";
import "./FreeTrialPageStyles.css"


function FreeTrialPage() {
  const location = useLocation();
  const message = location.state?.message;
  const header = location.state?.header;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
  const [responseLoading, setResponseLoading] = useState(true);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  
  useEffect(() => {
    checkGettingToKnowYouScriptStatus();
  }, []);

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (!isNull(response.conversation)) {
        response?.conversationCompleted && setGettingToKnowScriptStatus(true);
        setResponseLoading(true);
      } else {
        setGettingToKnowScriptStatus(false);
        setResponseLoading(true);
      }
    } catch (err) {
      console.log("In catch", err);
    }
  };

  const { Content } = Layout;
  const { Text } = Typography;

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const navigate = useNavigate();

  const handleConversationButtonClick = () => {
      navigate("/subs2")
  };

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  return (
    <div style={{minHeight: "100dvh" , overflow: "hidden"}} className="setEndBackground">
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={componentStyles.spacingBottom}
        >
          <Col xs={22} lg={24} md={22}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col xs={4} lg={4} md={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        <Content className="content">
          <Row justify="left" align="" className="main-row">
            <Col span={24} className="text-col">
              <h1 style={componentStyles.titleStyle}>
                {header}
              </h1>
              <Text className="text-para-style">
                {message}
              </Text>
              <br />

              <Button onClick={handleConversationButtonClick} style={componentStyles.button3} className="free-width-button">View Subscription Options</Button>
                <RouterLink
                  to="/landing-page"
                  style={{ textDecoration: "none" }}
                >
             
                </RouterLink> 
            </Col>
          </Row>
        </Content> 
      </Col>
    </div>
  );
}

export default FreeTrialPage;
